import { useQuery } from '@tanstack/react-query';
import { IGetLaunchedStates, IGetLaunchedStatesbody } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getLaunchedStates = async (params?: IGetLaunchedStatesbody) => {
  const res = await apiManager.get<IGetLaunchedStates>(
    "/admin/states/all",
    params
  );
  return res;
};


export const useGetLaunchedStates = (params?: IGetLaunchedStatesbody) =>
  useQuery({
    queryKey: ["get_launched_states", params],
    queryFn: async (): Promise<IGetLaunchedStates> => {
      const res = await apiClient.get(ENDPOINTS.STATES.GET_LAUNCHED_STATES, { params });
      return res.data;
    },
  });